import { api } from "../../api";
import {handleResponse, RequestOptions} from "../types";

const getListData = (data: any) => {
    return fetch(`${api.admin.reports.finance_report.list}`, {...RequestOptions('POST', JSON.stringify(data))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
}

export const financeReportService = {
    getListData,
};
